<template>
  <tr class="audits-table-item">
    <td>
      {{ audit.operation }}
    </td>

    <td>
      {{ audit.login }}
    </td>

    <td>
      {{ auditDate }}
    </td>

    <td class="audits-table-item-detail">
      <AuditsDetailModal v-tooltip="'Detalhes'"
                         :objectContent="audit.objectContent" />
    </td>
  </tr>
</template>

<script>
    import AuditsDetailModal from '@views/audits/components/AuditsDetailModal.vue';
    import moment from 'moment';

    export default {
      props: {
        audit: {
          type: Object,
          required: true
        }
      },
        components: {
            AuditsDetailModal
        },

        data() {
            return {

            }
        },

        computed: {
          auditDate() {
            const dateMoment = moment(this.audit.date)
            return `${dateMoment.format('LL')} às ${dateMoment.format('LT')}`
          }
        }

    }
</script>

<style lang="scss" scoped>
.audits-table-item {
  .audits-table-item-detail {
    // display: flex;
    // justify-content: center;
    // align-items: center;
  }
}
</style>
